import React from 'react';
import {
	useLocation,
	useNavigate
} from "react-router-dom";

const AuthContext = React.createContext(null);

const AuthProvider = ({ children }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const [loginToken, setLoginToken]	= React.useState(localStorage.getItem('login-token'));
	const [userId, setUserId]			= React.useState(localStorage.getItem('login-user-id'));
	const [userType, setUserType]		= React.useState(localStorage.getItem('login-user-type'));
	const [userName, setUserName]		= React.useState(localStorage.getItem('login-user-name'));

	const handleLogin = async (loginToken, userId, userType, userName) => {
		try {
			setLoginToken(loginToken);
			setUserId(userId);
			setUserType(userType);
			setUserName(userName);

			localStorage.setItem('login-token', loginToken);
			localStorage.setItem('login-user-id', userId);
			localStorage.setItem('login-user-type', userType);
			localStorage.setItem('login-user-name', userName);

			if(userType == 'PRINTER') {
				navigate('/printer');
			} else {
				const origin = location.state?.from?.pathname || '/home';
				navigate(origin);
			}
		} catch(err) {
			console.log("ERROR: " + err);
		}
	};

	const handleLogout = () => {
		setLoginToken(null);
		setUserId(null);
		setUserType(null);
		setUserName(null);
		localStorage.removeItem('login-token');
		localStorage.removeItem('login-user-id');
		localStorage.removeItem('login-user-type');
		localStorage.removeItem('login-user-name');
		navigate("/login");
	}

	const handleInvalidToken = () => {
		handleLogout();
	};

	const value = {
		loginToken,
		userId,
		userType,
		userName,
		onLogin: handleLogin,
		onLogout: handleLogout,
		handleInvalidToken
	}

	return (
		<AuthContext.Provider value={value}>
			{children}
		</AuthContext.Provider>
	);
}

export {
	AuthProvider,
	AuthContext
};
